export const SOCIAL = {
    GITHUB: 'https://github.com/Tin542',
    LINKEDIN: 'https://www.linkedin.com/in/thanh-tin-nguyen-86b407232/',
    FACEBOOK: 'https://www.facebook.com/thanhtin.nguyen.96930/'
}